import { Visibility } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  MenuItem,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../../../utils/routes";
import {
  useApproveBookingsMutation,
  useDeclineBookingsMutation,
  useDeleteBookingFacilityMutation,
  useGetBookingServicesQuery,
} from "../../../../../api/financeApi";
import { CalendarFilter2 } from "../../../../Components/Search/Search";
import editIcon from "./Edit-pen.svg";
import bin from "./bin.svg";
import { toast } from "react-toastify";
import { GetAllBookingService } from "../../../../../../utils/redux/HR/HRSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  FormatStatus,
  getColorByStatus,
} from "../../../../../../utils/functions/FormatStatus";
import { FormatDateTimeV2 } from "../../../../../../utils/functions/ResourceFunctions";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#F9FAFB",
  fontSize: "14px",
  fontWeight: "500",
  color: "#333",
  borderBottom: "none",
}));

const statusColors = {
  Active: "bg-green-100 text-green-700",
  Inactive: "bg-red-100 text-red-700",
  Maintenance: "bg-yellow-100 text-yellow-700",
};
const getStatusLabel = (status) => {
  if (status === 0) return "Inactive";
  if (status === 1) return "Active";
  if (status === 2) return "Maintenance";
};

const getStatusColor = (status) => {
  const label = getStatusLabel(status);
  return statusColors[label];
};

const Services = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const allBookedService = useSelector((x) => x?.hr?.all_booking_service);
  // console.log("allBookedService", allBookedService);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [facilityId, setFacilityId] = useState();
  const { data, isLoading, refetch } = useGetBookingServicesQuery({
    PageSize: rowsPerPage,
    PageNumber: page,
    Status: selectedStatus,
    startDate: FormatDateTimeV2(startDate),
    endDate: FormatDateTimeV2(endDate),
  });
  const tableData = data?.result?.items;
  const tablePagination = data?.result;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [approveBookings, { isLoading: isApproving }] =
    useApproveBookingsMutation();
  const [declineBookings, { isLoading: isDeclining }] =
    useDeclineBookingsMutation();

  const [onDelete, { isLoading: deleteLoading }] =
    useDeleteBookingFacilityMutation();

  const handleDelete = async () => {
    try {
      const res = await onDelete({ id: facilityId }).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        handleClose();
      } else {
        toast.error(res?.statusMessage);
      }
    } catch (error) {
      toast.error("An error occurred while deleting the booking facility.");
    }
  };

  const handleApprove = async () => {
    try {
      const res = await approveBookings({ id: facilityId }).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        handleClose();
        refetch();
      } else {
        toast.error(res?.statusMessage);
      }
    } catch (error) {
      toast.error("An error occurred while approving the booking facility.");
    }
  };

  const handleDecline = async () => {
    try {
      const res = await declineBookings({ id: facilityId }).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        handleClose();
        refetch();
      } else {
        toast.error(res?.statusMessage);
      }
    } catch (error) {
      toast.error("An error occurred while declining the booking facility.");
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filterBy = [
    // {
    //   name: "All",
    //   filter: 411,
    // },
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Declined",
      filter: 7,
    },
  ];

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <div>
      <div>
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center gap-3">
            <div className="flex flex-col">
              <span>Search</span>
              <TextField
                label="Search"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                size="small"
              />
            </div>
            <CalendarFilter2
              name="Select Date Range"
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
            <div className="flex flex-col">
              <span>Status</span>
              <TextField
                select
                label="Status"
                value={selectedStatus}
                onChange={handleStatusChange}
                variant="outlined"
                size="small"
                sx={{
                  width: 216,
                }}
              >
                <MenuItem></MenuItem>
                {filterBy.map((item) => (
                  <MenuItem key={item.filter} value={item.filter}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
          {/* <Button
            variant="contained"
            onClick={() =>
              navigate("/dashboard/finance/" + URL.CreateNewService)
            }
            style={{ backgroundColor: "#305F32", color: "#fff" }}
          >
            Book A Service
          </Button> */}
        </div>
        {isLoading && <p>Loading...</p>}
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>S/N</StyledTableCell>
                <StyledTableCell>Requisitor Name</StyledTableCell>
                <StyledTableCell>Service ID</StyledTableCell>
                <StyledTableCell>Facility ID</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
                <StyledTableCell>Date Requested</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.map((row, index) => (
                <TableRow key={row.id}>
                  <StyledTableCell>{index + 1}</StyledTableCell>
                  <StyledTableCell>{row?.requisitorName}</StyledTableCell>
                  <StyledTableCell>{row?.serviceId}</StyledTableCell>
                  <StyledTableCell>{row?.facilityId}</StyledTableCell>
                  <StyledTableCell>
                    {new Date(row?.startDate).toLocaleDateString()}{" "}
                    {new Date(row?.startDate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </StyledTableCell>
                  <StyledTableCell>
                    {new Date(row?.endDate).toLocaleDateString()}{" "}
                    {new Date(row?.endDate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </StyledTableCell>

                  <StyledTableCell>
                    {new Date(row?.createdDate).toLocaleDateString()}
                  </StyledTableCell>
                  <StyledTableCell>
                    <span
                      // className={`rounded-full px-2 py-1 ${getStatusColor(
                      //   row?.approvalStatus
                      // )}`}
                      style={{
                        color: getColorByStatus(row?.approvalStatus).color,
                        backgroundColor: getColorByStatus(row?.approvalStatus)
                          .backgroundColor,
                        padding: "4px", // Optional padding for better visual presentation
                        borderRadius: "4px", // Optional rounded corners
                      }}
                    >
                      {FormatStatus(row?.approvalStatus)}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell>
                    <div className="flex items-center">
                      <button
                        onClick={() => {
                          console.log(row, "this is a new role");
                          navigate(
                            "/dashboard/finance/Bookings-Service-Details/" +
                              row?.id
                          );
                        }}
                        className="bg-[#6E9170] rounded-l-md p-1"
                      >
                        <Visibility className="text-[#fff]" />
                      </button>
                      <div onClick={() => setFacilityId(row?.id)}>
                        <button
                          onClick={handleClick}
                          className="bg-[#4B664C] p-1 rounded-r-md"
                        >
                          <KeyboardArrowDownIcon className="text-[#fff]" />
                        </button>
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div className="p-3 flex flex-col gap-8 h-[100px] w-[130px]">
            <div className="flex gap-3 items-center">
              <svg
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.33333 7.66797V16.3346M9.75583 5.88491L10.0027 3.77826C10.1344 2.65478 9.25644 1.66797 8.12527 1.66797C7.74615 1.66797 7.40372 1.89451 7.25543 2.24342L5.01169 7.52282C4.80249 8.01505 4.31941 8.33464 3.78458 8.33464H3C1.89543 8.33464 1 9.23007 1 10.3346V14.3346C1 15.4392 1.89543 16.3346 3 16.3346H12.1581C13.051 16.3346 13.8358 15.7427 14.0811 14.8841L15.6049 9.55074C15.97 8.27311 15.0106 7.0013 13.6819 7.0013H10.749C10.1506 7.0013 9.68618 6.47926 9.75583 5.88491Z"
                  stroke="#008A00"
                  stroke-width="2"
                />
              </svg>

              <button onClick={handleApprove} disabled={isApproving}>
                {deleteLoading ? "loading..." : "Approve"}{" "}
              </button>
            </div>
            <div className="flex gap-3 items-center">
              <svg
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.33333 1.66797V10.3346M9.75583 12.1177L10.0027 14.2243C10.1344 15.3478 9.25644 16.3346 8.12527 16.3346C7.74615 16.3346 7.40372 16.1081 7.25543 15.7592L5.01169 10.4798C4.80249 9.98756 4.31941 9.66797 3.78458 9.66797H3C1.89543 9.66797 1 8.77254 1 7.66797V3.66797C1 2.5634 1.89543 1.66797 3 1.66797H12.1581C13.051 1.66797 13.8358 2.25992 14.0811 3.11853L15.6049 8.45186C15.97 9.72949 15.0106 11.0013 13.6819 11.0013H10.749C10.1506 11.0013 9.68618 11.5233 9.75583 12.1177Z"
                  stroke="#CA024F"
                  stroke-width="2"
                />
              </svg>
              <button onClick={handleDecline} disabled={isDeclining}>
                {deleteLoading ? "loading..." : "Decline"}{" "}
              </button>
            </div>
          </div>
        </Popover>
        <TablePagination
          component="div"
          count={tablePagination?.totalCount} // Total number of items
          page={page} // Current page (0-indexed)
          onPageChange={handleChangePage} // Function to handle page change
          rowsPerPage={rowsPerPage} // Current rows per page
          onRowsPerPageChange={handleChangeRowsPerPage} // Function to handle rows per page change
          rowsPerPageOptions={[5, 10, 25]} // Options for rows per page
          className="mt-4"
        />
      </div>
    </div>
  );
};

export default Services;
